"use strict";

require("core-js/modules/es6.symbol.js");

require("core-js/modules/es6.string.iterator.js");

require("core-js/modules/es6.array.from.js");

require("core-js/modules/es6.object.get-own-property-descriptor.js");

require("core-js/modules/es7.object.get-own-property-descriptors.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDecodedURIEmail = exports.fontColorForTheme = exports.overFieldNames = exports.processPackageServices = exports.checkLoadedScripts = exports.scaleRange = exports.filterServices = exports.formatTime = exports.normalizeStateProvince = exports.startDateISOSort = exports.timeWithZoneOffset = exports.renderCopyLikes = exports.formatAddress = exports.handleOnPageReady = exports.getURLParams = exports.getStartDate = exports.initFB = exports.loadFB = exports.loginWithFB = exports.dataURItoBlob = exports.postToImgCompressLambda = exports.getAccessorId = exports.renderDemoToast = exports.renderToast = exports.filterHomesByUser = exports.userHasAccess = exports.companyHasCRMAccess = exports.getEpochDays = exports.getZipLocation = exports.makePrettyEpoch = exports.randomColorFromString = exports.matchUrlPattern = exports.updatePageMeta = exports.getTitleAndDescriptionForHD = exports.trimCitySlug = exports.isAccessorManager = exports.isStaticMedia = exports.renderAuthModal = exports.checkLikes = exports.hasAtLeastOneField = exports.getTitle = exports.isFollowing = exports.shuffleArray = exports.getGender = exports.isAccessorType = exports.getAccessorTypes = exports.handleCommentReport = exports.handleCopy = exports.preventTabKeyPress = exports.addParamsToUrl = exports.addHttp = exports.groupSort = exports.formatLineBreaks = exports.capitalize = exports.getCreationType = exports.getPercentage = exports.getAgeString = exports.toEpoch = exports.getDateObj = exports.getDateDiff = exports.createDateTimeString = exports.commentDate = exports.formatPhoneNumber = exports.userContainsOne = exports.getUserTypes = exports.googleAnalytics = exports.possessiveNameString = exports.truncatedNameString = exports.nameString = exports.makeKey = void 0;

require("core-js/modules/es6.regexp.replace.js");

require("core-js/modules/es6.array.filter.js");

require("core-js/modules/es6.object.keys.js");

require("core-js/modules/es6.string.includes.js");

require("core-js/modules/es7.array.includes.js");

require("core-js/modules/es6.regexp.split.js");

require("core-js/modules/es6.array.map.js");

require("core-js/modules/es6.regexp.match.js");

require("core-js/modules/es6.array.slice.js");

require("core-js/modules/es6.array.find.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/web.dom.iterable.js");

require("core-js/modules/es7.object.entries.js");

require("core-js/modules/es6.regexp.to-string.js");

require("core-js/modules/es6.typed.uint8-array.js");

require("core-js/modules/es6.function.name.js");

require("core-js/modules/es6.string.starts-with.js");

var _react = _interopRequireDefault(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _dateFns = require("date-fns");

var _axios = _interopRequireDefault(require("axios"));

var _get = _interopRequireDefault(require("lodash/get"));

var _set = _interopRequireDefault(require("lodash/set"));

var _startCase = _interopRequireDefault(require("lodash/startCase"));

var _fromPairs = _interopRequireDefault(require("lodash/fromPairs"));

var _usStateCodes = _interopRequireDefault(require("us-state-codes"));

var _reactToastify = require("react-toastify");

var _constants = require("@evdy/web-redux/dist/constants");

var _repZones = require("@evdy/web-etc/dist/lib/repZones");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var replace = function replace(pattern) {
  return function (replacement) {
    return function (s) {
      return s.replace(pattern, replacement);
    };
  };
};

var makeKey = replace(/\s/)('');
exports.makeKey = makeKey;

var nameString = function nameString(name) {
  if (typeof name === 'string') return name;
  if (!name) return;
  var first = name.first,
      nickname = name.nickname,
      middle = name.middle,
      last = name.last,
      prefix = name.prefix,
      suffix = name.suffix;
  nickname = nickname && "\"".concat(nickname, "\"");
  return [prefix, first, nickname, middle, last, suffix].filter(Boolean).join(' ');
};
/**
 * Shortens name property to just the initial
 * @param {{first: String, nickname: String, middle: String, last: String, suffix: String}} name Name object containing properties for first or last name
 * @param {Number} maxLength The longest a name can be before truncating the property
 * @param {Array.<String>} forceTrunc Array of strings for which properties to force to be truncated
 * @returns {String} Shortened name string
 */


exports.nameString = nameString;

var truncatedNameString = function truncatedNameString(name) {
  var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var forceTrunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  if (!name) return;
  var truncatedName = {};
  Object.keys(name).forEach(function (n) {
    if (!name[n]) return;
    truncatedName[n] = name[n] && forceTrunc.includes(n) ? "".concat(name[n].substring(0, 1), ".") : name[n];
    truncatedName[n] = truncatedName[n].split && truncatedName[n].split(' ').map(function (n) {
      return n.length > maxLength ? "".concat(n.substring(0, 1), ".") : n;
    }).join(' ');
  });
  return nameString(truncatedName);
};

exports.truncatedNameString = truncatedNameString;

var possessiveNameString = function possessiveNameString(name) {
  var formattedName = nameString(name);
  if (!(formattedName !== null && formattedName !== void 0 && formattedName.length)) return '';
  var endsInS = formattedName[formattedName.length - 1] === 's';
  return endsInS ? "".concat(formattedName, "\u2019") : "".concat(formattedName, "\u2019s");
};

exports.possessiveNameString = possessiveNameString;

var googleAnalytics = function googleAnalytics(name) {
  var _global, _window;

  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'button_press';
  var customDimension = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if ((_global = global) !== null && _global !== void 0 && _global.window && window && (_window = window) !== null && _window !== void 0 && _window.ga) {
    return window.ga.bind(null, 'send', 'event', 'ui_action', type, name, customDimension);
  } else {
    return function () {};
  }
};

exports.googleAnalytics = googleAnalytics;

var getUserTypes = function getUserTypes() {
  var _user$meta;

  var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var userTypes = [];
  if (user !== null && user !== void 0 && user.isAFP) userTypes.push('isAFP');
  if (user !== null && user !== void 0 && user.isCompanyAdmin) userTypes.push('isCompanyAdmin');
  if (user !== null && user !== void 0 && (_user$meta = user.meta) !== null && _user$meta !== void 0 && _user$meta.everdaysAdmin) userTypes.push('everdaysAdmin');
  return userTypes;
};

exports.getUserTypes = getUserTypes;

var userContainsOne = function userContainsOne(user, conditionTypes) {
  var userTypes = getUserTypes(user);
  return conditionTypes.some(function (type) {
    return userTypes.includes(type);
  });
};

exports.userContainsOne = userContainsOne;

var formatPhoneNumber = function formatPhoneNumber(phoneNumberString) {
  var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    var intlCode = match[1] ? '+1 ' : '';
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }

  return '';
};

exports.formatPhoneNumber = formatPhoneNumber;

var commentDate = function commentDate(date) {
  var fromNow = (0, _moment.default)(date).fromNow(true);

  if (fromNow.includes('M')) {
    var weeks = fromNow.split('M');
    weeks = weeks[0] * 4 + 'w';
    return weeks;
  }

  return fromNow;
};

exports.commentDate = commentDate;

var createDateTimeString = function createDateTimeString(epoch, options) {
  var isDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (!epoch) {
    return '';
  }

  if (isDate) {
    return new Date(epoch).toLocaleDateString('en-US', options);
  }

  return new Date(epoch).toLocaleTimeString('en-US', options);
};

exports.createDateTimeString = createDateTimeString;

var getDateDiff = function getDateDiff(death, birth) {
  return function (format) {
    return (0, _moment.default)(death).diff((0, _moment.default)(birth), format);
  };
};

exports.getDateDiff = getDateDiff;

var getDateObj = function getDateObj(date) {
  var dateObj = {
    year: '',
    month: '',
    day: ''
  };

  if (date) {
    var mDate = _moment.default.utc(date);

    dateObj.year = mDate.year();
    dateObj.month = mDate.month();
    dateObj.day = mDate.date();
  }

  return dateObj;
};

exports.getDateObj = getDateObj;

var toEpoch = function toEpoch(date) {
  return (0, _moment.default)(date).valueOf();
};
/**
 * Determines whether to display years, months, days, or newborn for deceased age.
 * @param {Number} birth - Date of birth in milliseconds (Epoch Time)
 * @param {Number} death - Date of death in milliseconds (Epoch Time)
 * @param {Boolean} [parens] - Whether to wrap age string in parentesis.
 * @returns {String} Appropriate string for deceased age
 */


exports.toEpoch = toEpoch;

var getAgeString = function getAgeString(birth, death, parens) {
  if (!birth || !death) {
    return '';
  }

  var dayMs = 24 * 60 * 60e3;
  var yearMs = 365 * dayMs;
  var monthMs = 30 * dayMs;
  var diffMs = death - birth;
  var getDiff = getDateDiff(death, birth);
  var ageString = 'Newborn';

  if (diffMs >= 2 * yearMs) {
    ageString = "".concat(getDiff('years'), " years old");
  } else if (diffMs >= 2 * monthMs) {
    ageString = "".concat(getDiff('months'), " months old");
  } else if (diffMs >= 2 * dayMs) {
    ageString = "".concat(getDiff('days'), " days old");
  }

  return parens ? " (".concat(ageString, ")") : ageString;
};

exports.getAgeString = getAgeString;

var getPercentage = function getPercentage(memorial, percentagePoints) {
  var score = Object.keys(percentagePoints).reduce(function (E, x) {
    var val = (0, _get.default)(memorial, x);
    var point = percentagePoints[x];

    if (point.checkFn) {
      E += point.checkFn(val);
    } else if (Array.isArray(val)) {
      val.length && (E += point);
    } else {
      val && (E += point);
    }

    return E;
  }, 0);
  var percentage = score >= 85 ? 100 : score;
  return Math.round(percentage / 5) * 5;
};

exports.getPercentage = getPercentage;

var getCreationType = function getCreationType(memorial, display) {
  if (!memorial.apiUserId && memorial.createdByFuneralHome) {
    return 'Dash';
  }

  if (!memorial.apiUserId && !memorial.createdByFuneralHome) {
    return display ? 'Family' : 'DTC';
  }

  if (memorial.apiUserId === 'SRS') {
    return 'SRS';
  }

  if (memorial.apiUserId === 'continental:beth') {
    return 'CC';
  }

  if (memorial.apiUserId === 'passare') {
    return 'Passare';
  }

  return 'Dash';
};

exports.getCreationType = getCreationType;

var capitalize = function capitalize(text) {
  if (!text) return '';
  return text.replace(/\b\w/g, function (l) {
    return l.toUpperCase();
  });
};

exports.capitalize = capitalize;

var formatLineBreaks = function formatLineBreaks(text) {
  if (!text) return;
  return text.split(/\\n/).map(function (line, i, arr) {
    return /*#__PURE__*/_react.default.createElement("span", {
      key: i
    }, line);
  });
};

exports.formatLineBreaks = formatLineBreaks;

var groupSort = function groupSort() {
  var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var categories = '…abcdefghijklmnopqrstuvwxyz'.split('').map(function (l) {
    return {
      heading: l,
      entries: []
    };
  }); // group key:values by their first letter

  arr.forEach(function (obj) {
    if ((0, _get.default)(obj, key, '') === null) (0, _set.default)(obj, key, '');
    var startLetter = (0, _get.default)(obj, key, '').slice(0, 1).toLowerCase();
    var category = categories.find(function (_ref) {
      var heading = _ref.heading;
      return heading === startLetter;
    }) || categories[0];
    category.entries.push(obj);
  }); // filter empty categories

  categories = categories.filter(function (_ref2) {
    var entries = _ref2.entries;
    return !!entries.length;
  });
  categories.forEach(function (category) {
    category.entries = category.entries.sort(function (a, b) {
      var aName = (0, _get.default)(a, key, '').toLowerCase();
      var bName = (0, _get.default)(b, key, '').toLowerCase();
      if (aName < bName) return -1;
      if (aName > bName) return 1;
      return 0;
    });
  });
  return categories;
};

exports.groupSort = groupSort;

var addHttp = function addHttp(url) {
  return !/^(?:f|ht)tps?\:\/\//.test(url) ? 'http://' + url : url;
};

exports.addHttp = addHttp;

var addParamsToUrl = function addParamsToUrl() {
  var baseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var params = arguments.length > 1 ? arguments[1] : undefined;
  var pArray = Array.isArray(params) ? params : Object.entries(params);
  var url = addHttp(baseUrl) + (baseUrl.includes('?') ? '&' : '?') + pArray.shift().map(function (x) {
    return encodeURIComponent(x);
  }).join('=');
  return pArray.length ? addParamsToUrl(url, pArray) : url;
};
/**
 * Prevent tab key presses. Used on pages with React Swipeable Views to prevent a user
 * from being able to use the tab key to change between views which was causing a bug
 * that displayed a blank view.
 */


exports.addParamsToUrl = addParamsToUrl;

var preventTabKeyPress = function preventTabKeyPress(e) {
  if (e.key === 'Tab') {
    e.preventDefault();
  }
};

exports.preventTabKeyPress = preventTabKeyPress;

var handleCopy = function handleCopy(url) {
  var html = document.documentElement;
  var safari = document.body; // for Safari

  var currentScrollTop = html.scrollTop;
  var currentScrollTopSafari = safari.scrollTop;
  var textarea = document.createElement('textarea');
  textarea.value = url;
  document.body.appendChild(textarea);

  if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
    textarea.contentEditable = true; // if not inside <form>, must be contenteditable

    textarea.readOnly = true; // prevent keyboard from opening
    // create and select range

    var range = document.createRange();
    range.selectNodeContents(textarea);
    var selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    textarea.setSelectionRange(0, 999999);
  } else {
    textarea.focus();
    textarea.select();
  }

  try {
    document.execCommand('copy');
  } catch (err) {
    console.error('Error: unable to copy', err);
  }

  document.body.removeChild(textarea);
  html.scrollTop = currentScrollTop;
  safari.scrollTop = currentScrollTopSafari;
};
/**
 * Dispatches report action for share page comments
 * @param {Object} props
 * @param {Boolean} props.isDemo
 * @param {String} props.deceasedId
 * @param {Object} props.user
 * @param {Object} props.mediaId
 * @param {Function} props.dispatch
 * @param {Function} props.action
 * @param {Function} props.useToast
 * @param {Function} props.openSignUpModal
 */


exports.handleCopy = handleCopy;

var handleCommentReport = function handleCommentReport(props) {
  var isDemo = props.isDemo,
      deceasedId = props.deceasedId,
      user = props.user,
      mediaId = props.mediaId,
      dispatch = props.dispatch,
      action = props.action,
      useToast = props.useToast,
      openSignUpModal = props.openSignUpModal;
  var requiredProps = ['isDemo', 'deceasedId', 'user', 'mediaId', 'dispatch', 'action', 'useToast', 'openSignUpModal'];
  var checkProps = requiredProps.filter(function (prop) {
    return !Object.keys(props).includes(prop);
  });
  if (checkProps.length !== 0) return console.error("Missing Required Props: ".concat(checkProps.join(' ')));
  return function (e, commentId) {
    if (!mediaId || !commentId || !user && !e) return;

    if (!user.data) {
      openSignUpModal(e, 'basic', 'signup', 'comment');
      return;
    }

    if (isDemo) {
      openSignUpModal(null, 'basic', 'signup', '');
      return;
    }

    dispatch(action(deceasedId, mediaId, commentId));
    useToast('Comment Reported');
  };
};

exports.handleCommentReport = handleCommentReport;

var getAccessorTypes = function getAccessorTypes(accessorType) {
  var viewerType = '';
  var isFamily = false;

  switch (accessorType) {
    case 'manager':
    case 'managerByFh':
    case 'owner':
      isFamily = true;
      viewerType = 'manager';
      break;

    case 'viewer':
    case 'viewerToViewer':
      viewerType = 'viewer';
      break;

    default:
      viewerType = 'other';
  }

  return {
    viewerType: viewerType,
    accessorType: accessorType,
    isFamily: isFamily
  };
};

exports.getAccessorTypes = getAccessorTypes;

var isAccessorType = function isAccessorType(accessorType) {
  return function (_ref3) {
    var type = _ref3.type;

    switch (accessorType) {
      case 'family':
        return getAccessorTypes(type).isFamily;

      case 'community':
        return !getAccessorTypes(type).isFamily;

      default:
        // return unfiltered array
        return true;
    }
  };
};

exports.isAccessorType = isAccessorType;

var getGender = function getGender(relation) {
  if (/daughter|mother|sister|niece|aunt|wife/.test(relation)) {
    return 'f';
  } else if (/son|father|brother|nephew|uncle|husband/.test(relation)) {
    return 'm';
  }

  return 'u';
};

exports.getGender = getGender;

var shuffleArray = function shuffleArray(array) {
  var seed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var currentIndex = array.length;
  var temporaryValue = 0;
  var randomIndex = 0;
  var _seed = seed;

  var random = function random() {
    _seed = _seed + 1;
    var x = Math.sin(_seed) * 10000;
    return x - Math.floor(x);
  };

  while (currentIndex !== 0) {
    randomIndex = Math.floor(random() * currentIndex);
    currentIndex -= 1;
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
};

exports.shuffleArray = shuffleArray;

var isFollowing = function isFollowing(accessors, userId) {
  if (!accessors || !accessors.length || !userId) return null;
  return accessors.find(function (acc) {
    return (acc.userRef && acc.userRef._id ? acc.userRef._id.toString() : acc.userRef) === userId.toString();
  });
};

exports.isFollowing = isFollowing;

var getTitle = function getTitle(title) {
  if (title === 'presidentOrCEO') {
    return 'President / CEO';
  }

  return title && !/other/i.test(title) ? title.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) {
    return str.toUpperCase();
  }) : null;
};

exports.getTitle = getTitle;

var hasAtLeastOneField = function hasAtLeastOneField(obj) {
  return !!Object.entries(obj).filter(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
        key = _ref5[0],
        val = _ref5[1];

    return key !== '_id' && !!val;
  }).length;
};
/**
 * Checks to see if a user has liked a specific image
 * @param {Array.<Object>} likes - The array of likes of an image
 * @param {Object} user - The current user object
 * @returns {Boolean} Whether or not the user has liked the image
 */


exports.hasAtLeastOneField = hasAtLeastOneField;

var checkLikes = function checkLikes(likes, user) {
  if (!user || !likes || !user._id) return false;

  var stringUser = user._id.toString();

  return likes && likes.find(function (like) {
    if (!like.poster) return null;
    return like.poster._id ? like.poster._id.toString() === stringUser : like.poster.toString() === stringUser;
  });
};

exports.checkLikes = checkLikes;

var renderAuthModal = function renderAuthModal(user, location, children) {
  var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _opts$dlHideAuth = opts.dlHideAuth,
      dlHideAuth = _opts$dlHideAuth === void 0 ? false : _opts$dlHideAuth,
      _opts$hasOptions = opts.hasOptions,
      hasOptions = _opts$hasOptions === void 0 ? false : _opts$hasOptions;
  return _react.default.Children.map(children, function (child) {
    return /*#__PURE__*/_react.default.cloneElement(child, {
      user: user,
      pathname: location.pathname,
      dlHideAuth: dlHideAuth,
      hasOptions: hasOptions
    });
  });
};

exports.renderAuthModal = renderAuthModal;

var isStaticMedia = function isStaticMedia(_ref6) {
  var mediaType = _ref6.mediaType;
  return ['image', 'text'].includes(mediaType);
};

exports.isStaticMedia = isStaticMedia;

var isAccessorManager = function isAccessorManager(accessorType) {
  return ['owner', 'manager'].includes(accessorType);
};
/**
 * Removes any hyphenated numbering from city slugs due to slug generation of
 * multiple cities with the same name, (ex. 'evart-1', 'washington-13')
 * @param {string} citySlug
 */


exports.isAccessorManager = isAccessorManager;

var trimCitySlug = function trimCitySlug(citySlug) {
  return citySlug.split(/-[0-9]+/i).join('');
};
/**
 * getTitleAndDescriptionForHD returns the title and description for the page
 *
 * updatePageMeta handles the changing of the title and meta when pages are navigated
 */


exports.trimCitySlug = trimCitySlug;

var makePretty = function makePretty(type, part) {
  var prettyPart = (0, _startCase.default)(part);

  switch (type) {
    case 'country':
      prettyPart = prettyPart.toUpperCase();
      break;

    case 'state':
      prettyPart = _usStateCodes.default.getStateNameByStateCode(prettyPart);
      break;

    case 'citySlug':
      prettyPart = prettyPart.replace(/\d+/, '');
      break;

    default:
      break;
  }

  return prettyPart;
};

var getLocationCopy = function getLocationCopy(defaultCopy, city, state) {
  if (state && !city) return "in ".concat(state);else if (state && city && city !== 'All Cities') return "in ".concat(city, ", ").concat(state);else return defaultCopy;
};

var getHomeCopy = function getHomeCopy(defaultCopy, home) {
  return home ? "from ".concat(home) : defaultCopy;
};

var getTitleAndDescriptionForHD = function getTitleAndDescriptionForHD() {
  var urlParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var state = makePretty('state', urlParams.state);
  var city = makePretty('citySlug', urlParams.citySlug);
  var home = makePretty('home', urlParams.home);
  var titleStarter = "Find Obituaries ".concat(getHomeCopy('and Funeral Homes', home)).concat(home ? '' : getLocationCopy(''), " on Everdays");
  var descStarter = "Browse for obituaries and funeral homes ".concat(getLocationCopy('in your area', city, state), ".");
  return [titleStarter, descStarter];
};

exports.getTitleAndDescriptionForHD = getTitleAndDescriptionForHD;

var updatePageMeta = function updatePageMeta(document, urlParams) {
  var _getTitleAndDescripti = getTitleAndDescriptionForHD(urlParams),
      _getTitleAndDescripti2 = _slicedToArray(_getTitleAndDescripti, 2),
      title = _getTitleAndDescripti2[0],
      description = _getTitleAndDescripti2[1];

  document.title = title;
  document.description = description;
};
/**
 * Returns the match of a string to the UrlPattern
 * @param {UrlPattern} pattern - an instance of a UrlPattern()
 * @param {string} strToMatch - the string to match to the pattern
 */


exports.updatePageMeta = updatePageMeta;

var matchUrlPattern = function matchUrlPattern(pattern, strToMatch) {
  var match = pattern.match(strToMatch);
  if (!match) return;
  match._ = ''; // clear any extra subdirectories after the UrlPattern

  return pattern.stringify(match);
};

exports.matchUrlPattern = matchUrlPattern;

var randomColorFromString = function randomColorFromString(string) {
  var seed = [0].concat(_toConsumableArray(string)).reduce(function () {
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var letter = arguments.length > 1 ? arguments[1] : undefined;
    return letter.charCodeAt(0) + val;
  });
  var x = Math.sin(seed) * 10000;
  x = x - Math.floor(x);
  return "hsla(".concat(Math.round(x * 360), ", 56%, 52%, 1)");
};

exports.randomColorFromString = randomColorFromString;
var epochHour = 36e5;

var getEpochHoursFromMs = function getEpochHoursFromMs(epochMs) {
  return epochMs / epochHour;
};

var makePrettyEpoch = function makePrettyEpoch(epochMs) {
  var hours = getEpochHoursFromMs(epochMs);
  var useDays = hours > 48;
  var timeNumber = Math.round(useDays ? hours / 24 : hours);
  return "".concat(Math.abs(timeNumber), " ").concat(useDays ? 'day' : 'hour').concat(timeNumber === 1 ? '' : 's', " ").concat(timeNumber >= 0 ? 'after' : 'before');
};

exports.makePrettyEpoch = makePrettyEpoch;

var getZipLocation = function getZipLocation(zip) {
  if (!zip) return []; // more zip code regex's https://stackoverflow.com/questions/578406/what-is-the-ultimate-postal-code-and-zip-regex#answer-7185241

  var zipReg = {
    us: /^[0-9]{5}(?:-[0-9]{4})?$/,
    ca: /^([ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ])\s{0,1}(\d[ABCEGHJKLMNPRSTVWXYZ]\d)$/
  };
  return Object.entries(zipReg).map(function (_ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
        countryCode = _ref8[0],
        regex = _ref8[1];

    return !!zip.match(regex) && countryCode;
  }).filter(Boolean);
};

exports.getZipLocation = getZipLocation;

var getEpochDays = function getEpochDays(days) {
  return days * 1000 * 60 * 60 * 24;
};

exports.getEpochDays = getEpochDays;

var companyHasCRMAccess = function companyHasCRMAccess(funeralHomes) {
  return !!(funeralHomes !== null && funeralHomes !== void 0 && funeralHomes.length) && funeralHomes.some(function (fh) {
    return ['hlc', 'debug'].includes(fh.premiumProgram);
  });
};
/**
 *
 * @param {array} funeralHomes - An array of homes
 * @param {object} user - user object
 * @param {string} accessString = createView, display, reportsAccess, crmAccess
 * @return (boolean) Returns whether or not the user has access to any of the homes
 */


exports.companyHasCRMAccess = companyHasCRMAccess;

var userHasAccess = function userHasAccess(_ref9) {
  var funeralHomes = _ref9.funeralHomes,
      user = _ref9.user,
      accessString = _ref9.accessString;
  // set the user access to default to true for certain settings
  var defaultSetting = ['createView', 'display', 'reportsAccess'].includes(accessString);
  return !funeralHomes.length ? // if there are no homes, then there are is no reason to have user access
  false : // check all the homes individually
  funeralHomes.some(function (home) {
    var _home$users, _home$users2, _home$users3;

    var accessExistsInUsers = !((_home$users = home.users) !== null && _home$users !== void 0 && _home$users.length) ? // if no users at all, then revert to default setting
    defaultSetting : // check if the user exists
    !(home !== null && home !== void 0 && (_home$users2 = home.users) !== null && _home$users2 !== void 0 && _home$users2.some(function (u) {
      return u.userRef === user._id;
    })) ? //if they don't exist, then revert to default setting
    defaultSetting : // they do exist, now check for access for this particular user
    home === null || home === void 0 ? void 0 : (_home$users3 = home.users) === null || _home$users3 === void 0 ? void 0 : _home$users3.some(function (u) {
      return u[accessString] === true && u.userRef === user._id;
    });
    return accessExistsInUsers;
  });
};
/**
 *
 * @param {array} homes - array of homes
 * @param {object} user - user object
 * @param {array} parameters - an array of parameters: createView, display, reportsAccess, crmAccess
 * @return (object) Returns an object with an array of filteredHomes, and an array of filteredHomesIds
 */


exports.userHasAccess = userHasAccess;

var filterHomesByUser = function filterHomesByUser(_ref10) {
  var _ref10$homes = _ref10.homes,
      homes = _ref10$homes === void 0 ? [] : _ref10$homes,
      _ref10$user = _ref10.user,
      user = _ref10$user === void 0 ? {} : _ref10$user,
      _ref10$parameters = _ref10.parameters,
      parameters = _ref10$parameters === void 0 ? [] : _ref10$parameters;

  var filteredHomesIds = function filteredHomesIds(homesArray) {
    return _toConsumableArray(homesArray.map(function (home) {
      return home._id;
    }));
  };

  if (user.isCompanyAdmin || user.meta.everdaysAdmin) {
    return {
      filteredHomes: homes,
      filteredHomesIds: filteredHomesIds(homes)
    };
  }

  var filteredHomes = homes.filter(function (home) {
    var _home$users4;

    if (!((_home$users4 = home.users) !== null && _home$users4 !== void 0 && _home$users4.length)) {
      return true;
    }

    var checkUserValues = function checkUserValues() {
      var currentUserSettings = home.users.find(function (homeUser) {
        return homeUser.userRef === user._id;
      });

      if (currentUserSettings) {
        var hasFalsyValue = parameters.some(function (param) {
          return currentUserSettings[param] === false;
        });
        return !hasFalsyValue;
      } else {
        return true;
      }
    };

    return checkUserValues();
  });
  return {
    filteredHomes: filteredHomes,
    filteredHomesIds: filteredHomesIds(filteredHomes)
  };
};

exports.filterHomesByUser = filterHomesByUser;

var renderToast = function renderToast(_ref11) {
  var id = _ref11.id,
      message = _ref11.message,
      type = _ref11.type;

  if (!_reactToastify.toast.isActive(id)) {
    (0, _reactToastify.toast)(message, {
      position: _reactToastify.toast.POSITION.TOP_CENTER,
      autoClose: 3000,
      type: type === 'error' ? _reactToastify.toast.TYPE.ERROR : _reactToastify.toast.TYPE.INFO,
      toastId: id
    });
  }
};

exports.renderToast = renderToast;

var renderDemoToast = function renderDemoToast(_ref12) {
  var id = _ref12.id;
  return renderToast({
    id: id,
    message: 'Feature not available in demo mode.'
  });
};

exports.renderDemoToast = renderDemoToast;

var getAccessorId = function getAccessorId(accessor) {
  var _accessor$userRef;

  var id = (accessor === null || accessor === void 0 ? void 0 : (_accessor$userRef = accessor.userRef) === null || _accessor$userRef === void 0 ? void 0 : _accessor$userRef._id) || (accessor === null || accessor === void 0 ? void 0 : accessor._id) || '';
  return id.toString ? id.toString() : id;
};

exports.getAccessorId = getAccessorId;

var postToImgCompressLambda = function postToImgCompressLambda(url) {
  return _axios.default.post(_constants.LAMBDA_URL, {
    path: url
  }, {
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json'
    }
  });
};

exports.postToImgCompressLambda = postToImgCompressLambda;

var dataURItoBlob = function dataURItoBlob(dataURI) {
  // convert base64/URLEncoded data component to raw binary data held in a string
  var byteString;

  if (dataURI.split(',')[0].indexOf('base64') >= 0) {
    byteString = atob(dataURI.split(',')[1]);
  } else byteString = unescape(dataURI.split(',')[1]); // separate out the mime component


  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]; // write the bytes of the string to a typed array

  var blobData = new Uint8Array(byteString.length);

  for (var i = 0; i < byteString.length; i++) {
    blobData[i] = byteString.charCodeAt(i);
  }

  return new Blob([blobData], {
    type: mimeString
  });
};
/**
 *
 * @param {function} fbLogin - should be a dispatched fbLogin redux action
 * @param {function} fbPromiseReturn - fn to be run upon promise return
 */


exports.dataURItoBlob = dataURItoBlob;

var loginWithFB = function loginWithFB(_ref13) {
  var _ref13$sendUserKey = _ref13.sendUserKey,
      sendUserKey = _ref13$sendUserKey === void 0 ? false : _ref13$sendUserKey,
      _ref13$retries = _ref13.retries,
      retries = _ref13$retries === void 0 ? 0 : _ref13$retries,
      fbLogin = _ref13.fbLogin,
      _ref13$fbPromiseRetur = _ref13.fbPromiseReturn,
      fbPromiseReturn = _ref13$fbPromiseRetur === void 0 ? function () {} : _ref13$fbPromiseRetur;

  if (!window.FB) {
    if (retries > 4) return;

    window.fbAsyncInit = function () {
      var fb = window.FB;
      fb.init({
        appId: '1753611594959160',
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v3.0'
      });
    };

    return setTimeout(function () {
      return loginWithFB({
        sendUserKey: sendUserKey,
        retries: retries + 1
      });
    }, 100);
  }

  window.FB.login(function (_ref14) {
    var authResponse = _ref14.authResponse;
    if (!authResponse) return;
    var accessToken = authResponse.accessToken,
        fbId = authResponse.userID;
    var userKey = sendUserKey || '';
    fbLogin(accessToken, fbId, userKey).then(fbPromiseReturn);
  }, {
    scope: 'email'
  });
};

exports.loginWithFB = loginWithFB;

var loadFB = function loadFB() {
  (function (d, s, id) {
    if (d.getElementById(id)) return;
    var js = d.createElement(s);
    var fjs = d.getElementsByTagName(s)[0];
    js.id = id;
    js.src = 'https://connect.facebook.net/en_US/sdk.js';
    fjs.parentNode.insertBefore(js, fjs);
  })(document, 'script', 'facebook-jssdk');
};

exports.loadFB = loadFB;

var initFB = function initFB() {
  window.fbAsyncInit = function () {
    var fb = window.FB;
    fb.init({
      appId: '1753611594959160',
      autoLogAppEvents: true,
      xfbml: true,
      version: 'v3.0'
    });
  };
};
/**
 * Function takes a singular calendar name and an amount of time and returns
 * a moment object representing that day in the past
 *
 * @param {string} timePeriodType - singular calendar name 'day', 'month', 'year'
 * @param {number} timePeriodAmt - the amount of time period units before today's date
 */


exports.initFB = initFB;

var getStartDate = function getStartDate(timePeriodType) {
  var timePeriodAmt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  if (timePeriodType === 'day') return (0, _moment.default)().startOf(timePeriodType).subtract(timePeriodAmt, "".concat(timePeriodType, "s"));
  return (0, _moment.default)().subtract(timePeriodAmt, "".concat(timePeriodType, "s"));
};
/**
 * Takes a url pathname and return the string version of
 * the url params at the end without the '?'
 *
 * @param {Object} pathname - query params from react-router
 * @return (String) - the & joined string version
 */


exports.getStartDate = getStartDate;

var getURLParams = function getURLParams(pathname) {
  var params = pathname.match(/\?(.+)/);
  return params !== null ? params[1] : undefined;
};
/**
 * Takes a callback function and waits to run it until the
 * page has finished loading
 *
 * @param {function} cb - function to run when page is done loading
 */


exports.getURLParams = getURLParams;

var handleOnPageReady = function handleOnPageReady(cb) {
  if (document.readyState === 'ready' || document.readyState === 'complete') {
    cb();
  } else {
    document.onreadystatechange = function () {
      if (document.readyState === 'complete') cb();
    };
  }
};
/**
 * Takes an address object and returns a formatted string
 *
 * @param {Object} props
 * @param {String} props.street
 * @param {String} props.street1
 * @param {String} props.street2
 * @param {String} props.city
 * @param {String} props.state
 * @param {String} props.zip
 * @return (String) - the formated address string
 *
 */


exports.handleOnPageReady = handleOnPageReady;

var formatAddress = function formatAddress() {
  var _ref15 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref15$street = _ref15.street,
      street = _ref15$street === void 0 ? '' : _ref15$street,
      _ref15$street2 = _ref15.street1,
      street1 = _ref15$street2 === void 0 ? '' : _ref15$street2,
      _ref15$street3 = _ref15.street2,
      street2 = _ref15$street3 === void 0 ? '' : _ref15$street3,
      _ref15$city = _ref15.city,
      city = _ref15$city === void 0 ? '' : _ref15$city,
      _ref15$state = _ref15.state,
      state = _ref15$state === void 0 ? '' : _ref15$state,
      _ref15$zip = _ref15.zip,
      zip = _ref15$zip === void 0 ? '' : _ref15$zip,
      _ref15$address = _ref15.address,
      address = _ref15$address === void 0 ? '' : _ref15$address;

  address = !address ? "".concat(street || street1).concat(street2 ? " ".concat(street2) : '') : address;
  return "".concat(address, ", ").concat(city).concat(state ? ", ".concat(state) : '').concat(zip ? " ".concat(zip) : '');
};
/**
 * Takes properties of likeable media and returns the copy to
 * display how many likes the media has
 *
 * @param {Number} likesCount the amount of likes the content has
 * @param {Boolean} isLiked whether the content is already liked or not
 * @param {Array} likes array of all the previous likes
 */


exports.formatAddress = formatAddress;

var renderCopyLikes = function renderCopyLikes(_ref16) {
  var _mostRecentLike$poste;

  var likesCount = _ref16.likesCount,
      isLiked = _ref16.isLiked,
      _ref16$likes = _ref16.likes,
      likes = _ref16$likes === void 0 ? [] : _ref16$likes;
  var mostRecentLike = likes[likesCount - 1];
  var name = !!isLiked ? 'You' : (mostRecentLike === null || mostRecentLike === void 0 ? void 0 : mostRecentLike.poster) && nameString(mostRecentLike === null || mostRecentLike === void 0 ? void 0 : (_mostRecentLike$poste = mostRecentLike.poster) === null || _mostRecentLike$poste === void 0 ? void 0 : _mostRecentLike$poste.name) || '';
  if (!likesCount) return 'Be the first to Love';
  return likesCount === 1 ? name : "".concat(name, " and ").concat(likesCount - 1, " other").concat(likesCount > 2 ? 's' : '');
};

exports.renderCopyLikes = renderCopyLikes;

var timeWithZoneOffset = function timeWithZoneOffset(time) {
  if (!!time) return new Date(time.valueOf() + new Date(time).getTimezoneOffset() * 60 * 1000);
};
/***
 * sorts an array of services by a start date in ISO format
 * @param {array} Array an array of services with .startDateISO
 * @param {order} String defaults to 'ascending' - pass 'descending' to reverse
 */


exports.timeWithZoneOffset = timeWithZoneOffset;

var startDateISOSort = function startDateISOSort(array, order) {
  if (order === 'descending') {
    return array.sort(function (a, b) {
      return a.startDateISO > b.startDateISO ? -1 : a.startDateISO < b.startDateISO ? 1 : 0;
    });
  } else {
    return array.sort(function (a, b) {
      return a.startDateISO < b.startDateISO ? -1 : a.startDateISO > b.startDateISO ? 1 : 0;
    });
  }
};
/**
 * takes a state or province name and returns the capitalized abbreviation or empty string in nothing matches
 * @param {String} region - state or province name
 * @return (String) - capitalized abbreviation or empty string
 */


exports.startDateISOSort = startDateISOSort;

var normalizeStateProvince = function normalizeStateProvince() {
  var _stateProvince$region;

  var region = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var stateProvince = _objectSpread(_objectSpread({}, _repZones.states), {}, {
    provinces: _repZones.provinces
  });

  return ((_stateProvince$region = stateProvince[region.toLowerCase()]) === null || _stateProvince$region === void 0 ? void 0 : _stateProvince$region.normalized) || '';
};
/***
 * @param {Int} epochTime in ms or s
 */


exports.normalizeStateProvince = normalizeStateProvince;

var formatTime = function formatTime(time, specialFormatting) {
  return _moment.default.utc(new Date(time)).format(!!specialFormatting ? specialFormatting : 'LL') || '';
};
/***
 * @param {Array} servicesArray
 * filters out past events for nex upcoming event
 */


exports.formatTime = formatTime;

var filterServices = function filterServices(array) {
  return array.filter(function (s) {
    var isInPast = !(0, _dateFns.isPast)(timeWithZoneOffset(new Date(s.startDateISO)));
    var allDayInPast = !(0, _dateFns.isPast)((0, _dateFns.addHours)(timeWithZoneOffset(new Date(s.startDateISO)), 23));

    if (!s.startTimeTBD && isInPast) {
      return true;
    } else if (s.startTimeTBD && allDayInPast) {
      return true;
    } else if (s.startTimeTBD && !allDayInPast) {
      return false;
    }
  });
};
/**
 *
 * @param {number[]} prevRange - array with original low and high number
 * @param {number[]} range - array with new low and high number
 *
 * @return (Function) - function that takes a value and returns scaled number
 */


exports.filterServices = filterServices;

var scaleRange = function scaleRange(prevRange, range) {
  var _prevRange = _slicedToArray(prevRange, 2),
      prevMin = _prevRange[0],
      prevMax = _prevRange[1];

  var _range = _slicedToArray(range, 2),
      min = _range[0],
      max = _range[1];

  var prevDifference = prevMax - prevMin;
  var difference = max - min;
  return function (value) {
    return (value - prevMin) * difference / prevDifference + min;
  };
};
/**
 *
 * @param {String} scriptUrl - script url to crossreference with other loaded scripts
 *
 * @return (Boolean) - returns true if script is already loaded
 */


exports.scaleRange = scaleRange;

var checkLoadedScripts = function checkLoadedScripts(scriptUrl) {
  var loadedScripts = document.getElementsByTagName('script');

  var _iterator = _createForOfIteratorHelper(loadedScripts),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var script = _step.value;
      if (script.src === scriptUrl) return true;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return false;
};
/**
 *
 * @param {Object} preneedPackages - package object on a funeral home
 *
 * @return {Object} - returns an interable version of the price structure and
 * an iterable version of the data structure with package and service prices
 */


exports.checkLoadedScripts = checkLoadedScripts;

var processPackageServices = function processPackageServices(preneedPackages) {
  var _ref17 = preneedPackages || {},
      _ref17$dataStructure = _ref17.dataStructure,
      dataStructure = _ref17$dataStructure === void 0 ? {} : _ref17$dataStructure,
      _ref17$priceStructure = _ref17.priceStructure,
      priceStructure = _ref17$priceStructure === void 0 ? [] : _ref17$priceStructure;

  var prices = priceStructure.map(function (price) {
    var _Object$entries$;

    var _ref18 = (_Object$entries$ = Object.entries(price)[0]) !== null && _Object$entries$ !== void 0 ? _Object$entries$ : [],
        _ref19 = _slicedToArray(_ref18, 2),
        key = _ref19[0],
        value = _ref19[1];

    return {
      name: key,
      value: value
    };
  });

  var filterVersionAndIdKeys = function filterVersionAndIdKeys(packageId) {
    return /.*package.*/.test(packageId);
  };

  var packageIds = Object.keys(dataStructure).filter(filterVersionAndIdKeys);
  var serviceDetails = [];
  var packages = packageIds.map(function (packageId, idx) {
    var _dataStructure$packag;

    var _ref20 = (_dataStructure$packag = dataStructure[packageId]) !== null && _dataStructure$packag !== void 0 ? _dataStructure$packag : {},
        packageName = _ref20.packageName,
        serviceStructure = _ref20.services;

    var packageServices = Object.keys(serviceStructure).map(function (serviceId) {
      var _prices$find$value, _prices$find;

      var _serviceStructure$ser = serviceStructure[serviceId],
          type = _serviceStructure$ser.type,
          serviceName = _serviceStructure$ser.serviceName,
          description = _serviceStructure$ser.description,
          required = _serviceStructure$ser.required,
          isParent = _serviceStructure$ser.isParent,
          parentId = _serviceStructure$ser.parentId,
          serviceIndex = _serviceStructure$ser.serviceId,
          _serviceStructure$ser2 = _serviceStructure$ser.price,
          price = _serviceStructure$ser2 === void 0 ? null : _serviceStructure$ser2,
          hidden = _serviceStructure$ser.hidden,
          rest = _objectWithoutProperties(_serviceStructure$ser, ["type", "serviceName", "description", "required", "isParent", "parentId", "serviceId", "price", "hidden"]);

      var priceValue = (_prices$find$value = (_prices$find = prices.find(function (_ref21) {
        var name = _ref21.name;
        return name === serviceId;
      })) === null || _prices$find === void 0 ? void 0 : _prices$find.value) !== null && _prices$find$value !== void 0 ? _prices$find$value : null;

      var service = _objectSpread({
        type: type,
        serviceName: serviceName,
        description: description,
        required: required,
        isParent: isParent,
        parentId: parentId,
        serviceIndex: serviceIndex,
        hidden: hidden,
        price: priceValue !== null && priceValue !== void 0 ? priceValue : price,
        parentPackage: [{
          packageName: packageName,
          packageIdx: idx
        }]
      }, rest);

      if (!serviceDetails.map(function (_ref22) {
        var serviceIndex = _ref22.serviceIndex;
        return serviceIndex;
      }).includes(service.serviceIndex)) {
        serviceDetails = [].concat(_toConsumableArray(serviceDetails), [service]);
      } else {
        serviceDetails = serviceDetails.map(function (serviceDetail) {
          if (serviceDetail.serviceIndex !== service.serviceIndex) return serviceDetail;
          return _objectSpread(_objectSpread({}, serviceDetail), {}, {
            parentPackage: [].concat(_toConsumableArray(serviceDetail.parentPackage), [{
              packageName: packageName,
              packageIdx: idx
            }])
          });
        });
      }

      return service;
    });

    var cleanPrice = function cleanPrice(price) {
      if (price === undefined) return '0';
      return "".concat(price).replace(/[$,a-zA-Z]/g, '');
    }; // filter out services on each package that are addOns
    // addOns are not included in the package price so consumers can add them later during purchase


    var filteredPackageServices = packageServices.filter(function (_ref23) {
      var addOn = _ref23.addOn;
      return !addOn;
    });

    var reducer = function reducer(total, _ref24) {
      var serviceIndex = _ref24.serviceIndex,
          type = _ref24.type,
          price = _ref24.price;

      if (type === 'funeralhome') {
        // price is used from dataStructure[packageId].services. after addOns are filter the price from the services summed to get initial package price cost
        return +cleanPrice(price) + total;
      } // package prices are calculated off of type = funeralhome. type = everdays are free services at the moment
      // leaving the conditional in case type = everdays prices are added


      return (price !== null && price !== void 0 ? price : 0) + total;
    }; // get package price using the filtered servcies, (ie: non addOn services + raw package price)


    var packagePrice = filteredPackageServices.reduce(reducer, 0);
    return {
      packageName: packageName,
      packageId: packageId,
      packagePrice: packagePrice,
      packageServices: packageServices
    };
  }); // all services here and filter for add ons - array to compare with for submit

  return {
    packages: packages,
    services: serviceDetails
  };
};

exports.processPackageServices = processPackageServices;

var overFieldNames = function overFieldNames(keys, values) {
  var isObject = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
    return false;
  };
  return function (keyName) {
    return isObject(keyName) ? {
      key: keys[keyName],
      value: values[keyName]
    } : values[keyName];
  };
};
/**
 * Takes a design system color and maps to the apppropriate font color to use over top. Example: a
 * card that uses the background color of purple-love maps to a font color of white
 *
 * @param {String} themeColor - one of the defined design system colors
 *
 * @return {String} - returns either black or white
 */


exports.overFieldNames = overFieldNames;

var fontColorForTheme = function fontColorForTheme(themeColor) {
  return {
    black: 'white',
    'gray-dark': 'black',
    'gray-light': 'black',
    white: 'black',
    'card-bg': 'black',
    'photo-overlay': 'white',
    'bloody-mary-radial': 'white',
    'purple-dark': 'white',
    'purple-light': 'black',
    'almost-teal': 'black',
    'blue-everdays': 'white',
    'blue-light': 'black',
    red: 'white',
    'red-light': 'black',
    yella: 'black',
    'yella-light': 'black',
    green: 'black',
    'green-light': 'black',
    'purple-love': 'white',
    'kye-meh': 'white',
    sel: 'white',
    'bloody-mary': 'white',
    anamnisar: 'black',
    'blue-gradient': 'black'
  }[themeColor] || '';
};
/***
 * leaves special characters but but will decode %40 for '@'
 *
 * @param {String} queryParamsString
 */


exports.fontColorForTheme = fontColorForTheme;

var getDecodedURIEmail = function getDecodedURIEmail(queryParamsString) {
  var _queryParamsString$sp;

  return decodeURIComponent(queryParamsString === null || queryParamsString === void 0 ? void 0 : (_queryParamsString$sp = queryParamsString.split('?')[1]) === null || _queryParamsString$sp === void 0 ? void 0 : _queryParamsString$sp.split('&').find(function (queryString) {
    return queryString.startsWith('email=');
  }).split('=')[1]);
};

exports.getDecodedURIEmail = getDecodedURIEmail;